import { IconAlertCircle, IconCircleCheck, IconEye } from '@tabler/icons-react';

export type ActieTabKey = 'openstaand' | 'afgehandeld' | 'monitoring';

export type ActieTab = {
  key: ActieTabKey;
  label: string;
  icon: typeof IconAlertCircle;
};

// Single source of truth for the Acties-pagina tabs, shared with the header
// breadcrumb so the active tab's label appears there too.
export const ACTIE_TABS: ActieTab[] = [
  { key: 'openstaand', label: 'Openstaande acties', icon: IconAlertCircle },
  { key: 'afgehandeld', label: 'Afgehandeld', icon: IconCircleCheck },
  { key: 'monitoring', label: 'Monitoring', icon: IconEye },
];

export function isActieTabKey(value: unknown): value is ActieTabKey {
  return ACTIE_TABS.some((tab) => tab.key === value);
}
